import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { PhotoService } from '../../../../../app/shared/API-Service/services/photo.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Image } from '../../../../../images/images'
import { BaseComponent } from 'src/app/shared/components/base/base.component';



@Component({
  selector: 'app-view-photo',
  templateUrl: './view-photo.component.html',
  styleUrls: ['./view-photo.component.css']
})
export class ViewPhotoComponent extends BaseComponent implements OnInit {
  photoes:object [] = [];
  img : string = Image;
  constructor(private _PhotoService:PhotoService,private _Router:Router) {super() }

  ngOnInit(): void {
    this.getphoto();
  }
  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
   this.getphoto();
  }

  getphoto(){
    this._PhotoService.GetphotoPaged(this.pager).subscribe((res) => {
      this.photoes = res.data.items
      this.totalCount=res.data.totalCount;

    
    },(err)=>{
    },() =>{
    });
  }
  update(data){
    this._PhotoService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertPhoto']);
    }
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._PhotoService.Deletephoto(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getphoto();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
          })
        }
      }) 
    }
}
